import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {agregarItemArrayDoc} from "../../Servicios/BD/agregarItemArrayDoc";

export const empadrinarCuenta = async ({cuenta}) => {


    let arrPadres = []

    let idPadre = cuenta.codigoPadre

    let i = 0
    while (idPadre && i < 6) {


        let w = [where('codigo', '==', idPadre)]
        let doxPadre = await obtenerColWheres({col: 'cuentas', wheres: w})

        if (doxPadre.data[0]) {
            let cuentaPadre = doxPadre.data[0]
            let obj = {
                nombre: cuenta.nombre,
                idUsuario: cuenta.id,
                codigoUsuario: cuenta.codigo,
                img: cuenta.img,
            }

            await agregarItemArrayDoc({
                col: 'equipos',
                id: cuentaPadre.id,
                nombreArray: i,
                obj: obj
            })


            i++
            idPadre = cuentaPadre.codigoPadre
            arrPadres.push(cuentaPadre.id)
        }else{
            i++
            idPadre = null
        }


    }


    return arrPadres


    /*  let arrPadres = []

      let idPadre = cuenta.codigoPadre

      for (let i = 0; i < 6; i++) {

          if (idPadre) {

              let w = [where('codigo', '==', idPadre)]
              let doxPadre = await obtenerColWheres({col: 'cuentas', wheres: w})

              if (doxPadre.data[0]) {
                  let cuentaPadre = doxPadre.data[0]
                  let obj = {
                      nombre: cuenta.nombre,
                      idUsuario: cuenta.id,
                      codigoUsuario: cuenta.codigo,
                      img: cuenta.img,
                  }

                 await agregarItemArrayDoc({
                      col: 'equipos',
                      id: cuentaPadre.id,
                      nombreArray: i,
                      obj: obj
                  })


                  idPadre = cuentaPadre.codigoPadre
                  arrPadres.push(cuentaPadre.id)
              }


          }


      }


      return arrPadres */


}